import { render, staticRenderFns } from "./sellPanel.vue?vue&type=template&id=3bfea0af&scoped=true&"
import script from "./sellPanel.vue?vue&type=script&lang=js&"
export * from "./sellPanel.vue?vue&type=script&lang=js&"
import style0 from "./sellPanel.vue?vue&type=style&index=0&id=3bfea0af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfea0af",
  null
  
)

export default component.exports